import { IsBoolean, IsNumber, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';
import { ToBoolean } from '../utils/ToBoolean.util';
import { PaginationDTO } from '../common/Pagination.types';

export class SampleCounts<T = string> {
  counts?: VariantCounts<T>[];

  reportableCounts?: VariantCounts<T>[];

  targetableCounts?: VariantCounts<T>[];
}

export class VariantSeenInBiosample<T = string> {
  variantId: T;

  patientId: string;

  analysisSetId: string;

  sequencedEvent: string;

  biosampleId: string;

  zero2Category: string;

  zero2Subcategory1: string;

  zero2Subcategory2: string;

  zero2FinalDiagnosis: string;
}

export class VariantCounts<T = string> {
  variantId: T;

  count: number;

  zero2Category: string;

  zero2Subcategory1: string;

  zero2Subcategory2: string;

  zero2FinalDiagnosis: string;
}

export class VariantsCountsFiltersDTO {
  @IsBoolean()
  @ToBoolean()
  @IsOptional()
    reportable?: boolean;

  @IsBoolean()
  @ToBoolean()
  @IsOptional()
    targetable?: boolean;
}

export class VariantSeenInFiltersDTO extends PaginationDTO {
  @IsBoolean()
  @ToBoolean()
  @IsOptional()
    reportable?: boolean;

  @IsBoolean()
  @ToBoolean()
  @IsOptional()
    targetable?: boolean;
}

export class GeneCountsFiltersDTO {
  @Type(() => Number)
  @IsNumber({}, { each: true })
    geneIds: number[];
}

export class CNVVariantCounts<T = number> extends VariantCounts<T> {
  cnType: string;
}

export class CNVSampleCounts<T = number> {
  counts?: CNVVariantCounts<T>[];

  reportableCounts?: CNVVariantCounts<T>[];

  targetableCounts?: CNVVariantCounts<T>[];
}

export class CNVVariantSeenInBiosample<T = number> extends VariantSeenInBiosample<T> {
  cnType: string;
}
